import { createGlobalStyle } from 'styled-components';

const RadioStyle = createGlobalStyle`
  .radio{
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid ${({ theme }) => theme.colors.TextGamma};
  }
  .radio_mobile{
    @media screen and (max-width: 767px) {
      margin: 12px 0 8px;
      display: inline-block;
    }
  }
`;

export default RadioStyle;
